import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import { IRetailerDTO } from 'src/app/shared/api/models/v1/retailer';
import { IUserDTO } from 'src/app/shared/api/models/v1/user';
import { UserPermissionEnum } from 'src/app/shared/enums/user-permission';
import { UserRoleEnum } from 'src/app/shared/enums/user-role';

import { ApiService } from 'src/app/shared/api/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';

/*
  Using DaisyDropdownComponent (user supplied) to replace ngbDropdown
*/
import { DaisyDropdownComponent } from 'src/app/ui/dropdown.component';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DaisyDropdownComponent
  ],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Input() retailers: IRetailerDTO[] = [];
  public authUser?: IUserDTO | null;
  public authUserRole: string = 'User';
  public isSystemAdmin = false;
  public retailer?: IRetailerDTO | null;
  public sidebarSize: string | null = null;

  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(DOCUMENT) private document: any,
    private authService: AuthService,
    private api: ApiService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.authUser = this.authService.getUser();

    this.loadAuthUserRole();
    this.subscriptions.push(this.authService.user$.subscribe((user: IUserDTO | null) => {
      this.authUser = user;
      this.loadAuthUserRole();
    }));

    this.checkAuth();

    this.checkSidebarState();
    setInterval(() => {
      this.checkSidebarState();
    }, 100);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  private checkSidebarState() {
    this.sidebarSize = document.documentElement.getAttribute('data-sidebar-size');
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  public onToggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  public onLogout() {
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }

  private async loadAuthUserRole() {
    this.authUserRole = !this.authUser ? '' : this.authUser.roles.findIndex(x => x.role == UserRoleEnum.Website && x.permission == UserPermissionEnum.Admin) > -1 ? 'Admin' : 'User';
    this.isSystemAdmin = !this.authUser ? false : this.authUser.roles.findIndex(x => x.role == UserRoleEnum.System && x.permission == UserPermissionEnum.Admin) > -1 ? true : false;

    if (this.isSystemAdmin) {
      this.retailer = await this.api.retailers.getByAuthAsync();
    }
  }

  private async checkAuth() {
    if (this.authService.isAuthenticated()) {
      try {
        if (await this.authService.refreshAuthUserAsync()) {
          await this.authService.startRefreshAsync();
        } else {
          this.authService.logout();
          this.router.navigate(['/', 'auth', 'login']);
        }
      } catch (error) {
        this.authService.logout();
        this.router.navigate(['/', 'auth', 'login']);
      }
    }
  }
}